import { z } from 'zod'

export const LanguagePreferenceEnum = z.enum(['en', 'es'])
// Needs to include the redundant '&' to duplicate the type because the app will fail to compile when used in hook form
// This may be fixed in the future, but for now we need to keep the '&' even though it appears redundant
export type LanguagePreference = z.infer<typeof LanguagePreferenceEnum> & 'en' | 'es'
